import { CircleProps, Circle as GCircle } from '@react-google-maps/api';
import { useCallback, useRef } from 'react';

interface Props<T> extends CircleProps {
  onSelect?: (value?: T) => void;
  value?: T;
  color: string;
  index: number;
  allowFloat?: boolean;
  /**
   * radius in km
   *
   * @memberof Props
   */
  onEdit?: (radius: number) => void;
}

export const Circle = <T,>({ index, ...props }: Props<T>) => {
  const ref = useRef<GCircle | null>(null);

  const onClick = useCallback(
    (event: google.maps.MapMouseEvent) => {
      if (props.onSelect) props.onSelect(props.value);
      if (props.onClick) props.onClick(event);
    },
    [props.onSelect, props.value]
  );

  const onEdit = () => {
    let radius = ref.current?.state.circle?.getRadius();
    if (radius) {
      // rounded up if only integers
      if (!props.allowFloat) {
        radius = Math.round(radius / 1000);
      } else {
        radius = radius / 1000;
      }

      if (radius !== props.radius) {
        if (props.onEdit) props.onEdit(radius);
      }
    }
  };

  return (
    <GCircle
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      onRadiusChanged={onEdit}
      ref={ref}
      onClick={onClick}
      radius={(props.radius || 0) * 1000}
      options={{
        fillColor: props.color,
        strokeColor: props.color,
        fillOpacity: 0.4,
        zIndex: index + 1 || 1,
      }}
    />
  );
};
